import { Link, Paper, Typography } from '@mui/material';
import type { SecurityScanResult } from '../types';

const PORTAL =
  (import.meta.env.VITE_SECURITY_PORTAL_URL as string | undefined) ||
  'https://security.provalab.io';

function safeHttps(url: string | undefined | null): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.toString() : null;
  } catch {
    return null;
  }
}

export default function SecurityPanel({ scanResult }: { scanResult: SecurityScanResult }) {
  const link = safeHttps(scanResult.portal_url ?? scanResult.run_url);
  return (
    <Paper variant="outlined" sx={{ p: 2 }} data-testid="security-panel">
      <Typography variant="subtitle2" gutterBottom>
        Security scan
      </Typography>
      {link ? (
        <Typography variant="body2">
          This scan ran in the ProvaLab Security Portal.{' '}
          <Link href={link} target="_blank" rel="noopener noreferrer">
            Open in the Security Portal
          </Link>
        </Typography>
      ) : (
        <Typography variant="body2">
          Security scanning now runs in the Security Portal; this message predates the move.{' '}
          <Link href={PORTAL} target="_blank" rel="noopener noreferrer">
            Open the Security Portal
          </Link>
        </Typography>
      )}
    </Paper>
  );
}
